import React, { useContext, useState } from "react";
import Logo from "../../assets/logo.svg"
import MenuContext from "../../contexts/menu";
import AuthContext from "../../contexts/auth";
import styles from './header.module.css'
import { IoMenu } from "react-icons/io5";
import Options from "../select/options";
import { CustumerContext } from "../../contexts/custumer";
import Select from "../select";
import Text from "../text";
import { useHistory } from "react-router-dom";
import { FaUser } from "react-icons/fa";


const Content: React.FC = ({ children }) => {
  const { toggleMenu } = useContext(MenuContext);
  const { loggedEmail } = useContext(AuthContext);
  const [showOptions, setShowOptions] = useState<boolean>(false)
  const { current_custumer_description, selectCurrentCustumer, custumer_list, deleteList } = useContext(CustumerContext)
  const history = useHistory();

  function goToUsers() {
    history.push({ pathname: '/usuarios' });
  }

  return (
    <>
      {showOptions && <Options close={() => setShowOptions(false)} selectOption={selectCurrentCustumer} itens={custumer_list} sortAlphabetically />}
      <header className="flex items-center justify-between px-5 py-2.5 bg-white z-40 h-[60px] min-h-0" style={{ gridArea: 'header' }}>
        <div className="flex gap-4 justify-center items-center">
          <button className={`p-1 border-0 bg-transparent cursor-pointer ${styles.menu}`} onClick={toggleMenu}>
            <IoMenu size={28} />
          </button>

          <Select
            noBorder={true}
            noBackgroundColor={true}
            onOpenOptions={() => setShowOptions(true)}
            label={current_custumer_description}
          />
        </div>
        {/* <img src={Logo} alt="" /> */}
        <div className="flex justify-center items-center gap-1">
          <Text className={`!ml-auto !text-gray-400 !font-bold !px-2.5 ${styles.loggedEmail}`}>{loggedEmail}</Text>
          <div className="w-[35px] h-[35px] rounded-full bg-[#1566A4] overflow-hidden flex items-center justify-center cursor-pointer transition-all duration-300 hover:brightness-[.85] max-[1024px]:w-[35px] max-[1024px]:h-[35px]"
            onClick={goToUsers}>
            <FaUser color="#fff" size={14} />
          </div>
        </div>
      </header>
    </>
  )
}

export default Content;